export default {"src":"/_next/static/media/quote-marks.7865a3fb.svg","height":185,"width":256,"blurWidth":0,"blurHeight":0};